import { createSelector } from 'reselect';

const getLanguage = (state) => state.config?.language;
const getLoading = (state) => state.loading?.isLoading;
const getHeaderInfo = (state) => {
    const { headerImg, headerUrl, headerAlt } = state.productConfig || {};

    return {
        headerImg,
        headerUrl,
        headerAlt
    };
};

export const getHeaderState = createSelector(
    [getLoading, getLanguage, getHeaderInfo],
    (loading, language, headerInfo) => (
        {
            loading,
            language,
            headerInfo
        }
    )
);
